import Editor from './components/Layout';
export default Editor;



// WEBPACK FOOTER //
// ./src/routes/project/index.js